// Domínios do CTe sem Nota Fiscal

export const CTE_ROTULOS_TOMADOR = {
  0: 'Remetente',
  1: 'Expedidor',
  2: 'Recebedor',
  3: 'Destinatário',
  4: 'Outros',
}

export const CTE_PAPEL_POR_TOMADOR = {
  0: 'remetente',
  1: 'expedidor',
  2: 'recebedor',
  3: 'destinatario',
}

export const CTE_PARTE_ORIGENS = [
  { value: 'empresa', label: 'Empresa cadastrada' },
  { value: 'cliente', label: 'Cliente cadastrado' },
  { value: 'tp', label: 'Operador Logístico cadastrado' },
  { value: 'manual', label: 'Preencher manualmente' },
]

export const CTE_TIPOS_PESSOA = [
  { value: 'PJ', label: 'Pessoa Jurídica' },
  { value: 'PF', label: 'Pessoa Física' },
]

export const CTE_SITUACOES_ICMS_PARTE = [
  { value: 'contribuinte', label: 'Contribuinte do ICMS (com IE)' },
  { value: 'isento', label: 'Contribuinte isento de IE' },
  { value: 'nao_contribuinte', label: 'Não contribuinte' },
]

// Domínio SEFAZ cUnid, com o tipo de medida sugerido para cada unidade
export const CTE_UNIDADES_CARGA = [
  { value: '01', label: 'KG - Quilogramas', tipoMedidaPadrao: 'PESO BRUTO' },
  { value: '03', label: 'UN - Unidades', tipoMedidaPadrao: 'UNIDADES' },
  { value: '02', label: 'TON - Toneladas', tipoMedidaPadrao: 'PESO BRUTO' },
  { value: '00', label: 'M3 - Metros cúbicos', tipoMedidaPadrao: 'CUBAGEM' },
  { value: '04', label: 'L - Litros', tipoMedidaPadrao: 'LITRAGEM' },
]

// tpMed é texto livre na SEFAZ (1 a 20 caracteres); a lista reúne os exemplos do MOC e os usos comuns
export const CTE_TIPOS_MEDIDA = [
  'PESO BRUTO',
  'PESO DECLARADO',
  'PESO CUBADO',
  'PESO AFORADO',
  'PESO AFERIDO',
  'PESO BASE DE CALCULO',
  'UNIDADES',
  'CAIXAS',
  'VOLUMES',
  'PALLETS',
  'CUBAGEM',
  'LITRAGEM',
].map(value => ({ value, label: value }))

// Domínio SEFAZ tpDoc (infOutros); 59/65 só em prestação dentro da mesma UF (rejeição 813)
export const CTE_TIPOS_OUTROS_DOCUMENTOS = [
  { value: '99', label: '99 - Outros' },
  { value: '00', label: '00 - Declaração' },
  { value: '59', label: '59 - CF-e SAT', somenteIntraestadual: true },
  { value: '65', label: '65 - NFC-e', somenteIntraestadual: true },
]

// UFs que não aceitam tomador isento de Inscrição Estadual (rejeição 617)
export const CTE_UFS_SEM_TOMADOR_ISENTO = [
  'AM',
  'BA',
  'CE',
  'GO',
  'MG',
  'MS',
  'MT',
  'PE',
  'RN',
  'SE',
  'SP',
]
